const cookieName = 'auth_ticket';

export const setCookie = (
  value: any,
  name = cookieName,
  minutes = 3,
  path = '/',
) => {
  const expires = new Date(Date.now() + minutes * 1000 * 60).toUTCString();
  const { hostname } = new URL(process.env.REACT_APP_LOGIN_URL!);
  const isProd =
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_ENV !== 'local';

  // Set ENV variable for domain during local dev.
  const domain = isProd ? 'parapetstudios.com' : hostname;
  let cookie =
    name +
    '=' +
    encodeURIComponent(value) +
    '; expires=' +
    expires +
    `; domain=${domain}` +
    '; path=' +
    path +
    '; ';
  cookie += isProd ? 'SameSite=Lax; Secure;' : '';
  document.cookie = cookie;
  console.log('cookie : set cookie :', cookie);
};

export const getCookie = (name = cookieName): string => {
  console.log('get cookie');
  const cookie = document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
  return cookie;
};

export const deleteCookie = (name = cookieName, path = '/') => {
  setCookie(name, '', -1, path);
};

const cookie = {
  set: setCookie,
  get: getCookie,
  delete: deleteCookie,
};

export type Cookie = typeof cookie;

export default cookie;
